import axios from 'axios';
import Account from './main-views/Account';
import { MdChevronLeft } from 'react-icons/md';
import LoginView from './views/LoginView';
import ContactUs from './views/ContactUs';
import Notifications from './main-views/Notifications';
import MainMenu from './main-views/MainMenu';
import Sales from './main-views/Sales';
import RegisterBusiness from './views/RegisterBusiness';
import ChangeBusiness from './views/ChangeBusiness';
import Clients from './main-views/Clients';
import RegisterClient from './views/RegisterClient';
import RegisterVendor from './views/RegisterVendor';
import ViewClient from './views/ViewClient';
import ViewVendor from './views/ViewVendor';
import Vendors from './main-views/Vendors';
import StockItems from './main-views/StockItems';
import NonStockItems from './main-views/NonStockItems';
import RegisterStockItem from './views/RegisterStockItem';
import RegisterNonStockItem from './views/RegisterNonStockItem';
import RecordSale from './views/RecordSale';
import ViewStockItem from './views/ViewStockItem';

export const BASE_API = 'https://bizsuiteapi.werenium.com/api/';

export const CDN_URL = 'https://bizsuite.werenium.com/cdn/'


export function getMainView(app) {
  if (app.navItem === 'main-menu' || !app.navItem) {
    return <MainMenu />;
  } else if (app.navItem === 'account') {
    return <Account />;
  } else if (app.navItem === 'notifications') {
    return <Notifications />;
  } else if (app.navItem === 'sales') {
    return <Sales />;
  } else if (app.navItem === 'clients') {
    return <Clients />;
  } else if (app.navItem === 'vendors') {
    return <Vendors />;
  } else if (app.navItem === 'stock-items') {
    return <StockItems />;
  } else if (app.navItem === 'non-stock-items') {
    return <NonStockItems />;
  }

  return null;
}


export function getViewerView(app) {
  if (
    app.navSubItem === 'login' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LoginView />;
  } else if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'register-business' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterBusiness />;
  } else if (
    app.navSubItem === 'change-business' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ChangeBusiness />;
  } else if (
    app.navSubItem === 'register-client' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterClient />;
  } else if (
    app.navSubItem === 'register-vendor' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterVendor />;
  } else if (
    app.navSubItem === 'register-stock-item' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterStockItem />;
  } else if (
    app.navSubItem === 'register-non-stock-item' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterNonStockItem />;
  } else if (
    app.navSubItem === 'record-sale' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RecordSale />;
  } 


  return null;
}

export function getSideViewerView(app) {
  if (
    app.navSubItem === 'client' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewClient uuid={app.navExtraItem}/>
  } else if (
    app.navSubItem === 'vendor' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewVendor uuid={app.navExtraItem}/>
  } else if (
    app.navSubItem === 'register-client' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RegisterClient />;
  } else if (
    app.navSubItem === 'stock-item' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewStockItem uuid={app.navExtraItem}/>
  } 

  return null;
}

export function getBottomViewerView(app) {

  if (
    app.navSubItem === '' &&
    app.navExtraItem &&
    app.navMoreItem
  ) {
    return <></>; //just a template
  } 

  return null;
}

export function getTopBarTitle(app) {
  if (app.navItem === 'account') {
    return "Account";
  } 

  return "Werenium";
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}

export function remove255(input) {
  if (input.startsWith('255')) {
    return '0' + input.slice(3);
  }
  return input;
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function formatDateForInput(timestamp) {
  // Convert timestamp from seconds to milliseconds
  const date = new Date(timestamp * 1000);

  // Extract year, month, and day with padding for month and day if needed
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  // Format the date as YYYY-MM-DD for input type="date"
  return `${year}-${month}-${day}`;
}

export function isSameWeek(date) {
  const today = new Date();
  const currentWeekDay = today.getDay();
  const firstDayOfWeek = new Date(today.setDate(today.getDate() - currentWeekDay)); // Sunday
  const lastDayOfWeek = new Date(today.setDate(today.getDate() + 6)); // Saturday

  return date >= firstDayOfWeek && date <= lastDayOfWeek;
};

export function isSameMonth(date) {
  const today = new Date();
  return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      //..
      //call main api
      let formData = new FormData();

      //append lnguage
      formData.append('language', getCookie('language'));

      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      axios.post(BASE_API + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {

        console.log(url, response.data);

        resolve(response.data);
      }).catch(error => {
        resolve({
          status: 0,
          msg: "Network Connection Error",
        })
      })
      //..
    })

  })
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('userId');
    let userToken = getCookie('userToken');
    let userType = getCookie('userType');

    resolve({
      userId,
      userToken,
      userType,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  cname = 'bizapp-user-'+cname;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();

  // Get the current domain from window.location.hostname
  let domain = window.location.hostname;

  // Set domainPart only if it's not 'localhost'
  let domainPart = domain !== 'localhost' ? `;domain=${domain}` : '';

  // Add the SameSite attribute to restrict cross-origin access (Strict or Lax as per your needs)
  let sameSite = ";SameSite=Strict";

  // Add the Secure flag for HTTPS connections
  let secureFlag = window.location.protocol === 'https:' ? ";Secure" : '';

  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + domainPart + sameSite + secureFlag;
}


export function getCookie(cname) {
  cname = 'bizapp-user-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function formatMoney(x) {
  x = Number(x);

  // Check if the number has a decimal part
  let hasDecimal = x % 1 !== 0;

  // Format based on whether there's a decimal
  x = hasDecimal ? x.toFixed(2) : x.toString();

  // Split into integer and decimal parts
  var parts = x.split(".");
  
  // Add comma separation to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number, with decimals only if present
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function strtotime(dateString) {
  const date = new Date(dateString);

  // Check if time part is missing in the date string
  if (dateString.trim().length <= 10) { // If length is 10, it's just 'YYYY-MM-DD'
    date.setHours(23, 59, 59, 999); // Set time to the end of the day (23:59:59.999)
  }

  return Math.floor(date.getTime() / 1000);
}
